<template>
  <div class="transferManage column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width180 margin-left10">
          <el-input placeholder="调拨单号" style="width: 100%;" clearable v-model="orderNum"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="药品名称" style="width: 100%;" clearable v-model="drugName"></el-input>
        </div>
        <div class="width120 margin-left10">
          <el-select v-model="selectState" placeholder="状态" style="width: 100%;" filterable clearable>
            <el-option v-for="item in stateArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width150 margin-left10">
          <el-select v-model="selectHouseOut" placeholder="调出库房" style="width: 100%;" filterable clearable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width150 margin-left10">
          <el-select v-model="selectHouseIn" placeholder="调入库房" style="width: 100%;" filterable clearable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
        <div class="flex1"></div>
        <div class="btn-blue width140 btn-height40 margin-left40" @click="clickAdd" v-if="canOperate">新增调拨</div>
        <div class="btn-blank-blue width140 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="column-me flex1 margin-top20">
        <div class="table-border">
          <el-table ref="tableTransferManage" :data="tableData" header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style">
            <el-table-column prop="orderNo" label="调拨单号" align="left" width="200"></el-table-column>
            <el-table-column prop="status" label="状态" align="left" show-overflow-tooltip>
              <template #default="scope">
                {{ scope.row.status === 1 ? '待调拨' : scope.row.status === 2 ? '已完成' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="outPharmacyName" label="调出库房" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="inPharmacyName" label="调入库房" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="breedNum" label="品种" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nums" label="数量" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="price" label="金额" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="operator" label="操作人" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="left" width="230"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="completeTime" label="完成时间" align="left" width="230"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="center" width="150" v-if="canOperate">
              <template v-slot="scope">
                <div class="row-me row-center padding-left10">
                  <div class="blue-text margin-right30" v-if="scope.row.status===1"
                       @click.stop="clickEdit(scope.row)">编辑
                  </div>
                  <div class="blue-text margin-right30" v-if="scope.row.status===2"
                       @click.stop="clickDetail(scope.row)">详情
                  </div>
                  <div class="blue-text" @click.stop="clickDelete(scope.row)" v-if="scope.row.status===1">删除</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150" v-else>
              <template v-slot="scope">
                <div class="row-me center-all">
                  <div class="blue-text" v-if="scope.row.status===2"
                       @click.stop="clickDetail(scope.row)">详情
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>


    <!-- 新增调拨单 -->
    <el-dialog :title="title" v-model="visibleEdit" width="1300px" top="5vh" :destroy-on-close="true"
               :before-close="beforeClose" :close-on-click-modal="canMaskClose" :close-on-press-escape="canMaskClose">
      <div class="dialog-content column-me">
        <div class="row-me row-center grey-div">
          <div class="row-me row-center">
            <div><span class="red-star">*</span>调出库房：</div>
            <div class="width150">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                         v-model="selectItem.outPharmacyId" :disabled="selectItem.status===2"
                         :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.outPharmacyId)}">
                <el-option v-for="item in houseArray" :key="item.id" :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-left40">
            <div><span class="red-star">*</span>调入库房：</div>
            <div class="width150">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                         v-model="selectItem.inPharmacyId" :disabled="selectItem.status===2"
                         :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.inPharmacyId)}">
                <el-option v-for="item in houseArray" :key="item.id" :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-left30 flex1">
            <div>备注：</div>
            <div class="flex1">
              <el-input placeholder="请输入备注" style="width: 100%;" clearable v-model="selectItem.remark"
                        maxlength="500" :disabled="selectItem.status===2">
              </el-input>
            </div>
          </div>
        </div>
        <div class="overflow-auto" style="max-height: 450px;">
          <div class="column-me margin-top20" id="drugDiv">
            <div>
              <el-table :data="selectItem.details" border header-cell-class-name="table-header-style"
                        cell-class-name="table-cell-style" row-key="id" :default-expand-all="true"
                        :tree-props="{ children: 'batchNosShow' }">
                <el-table-column prop="drugName" label="药品名称" align="center" width="130" show-overflow-tooltip>
                  <template #default="scope">
                    <span>{{ scope.row.isChild ? '' : scope.row.drugName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="spec" label="规格" align="center" width="130" show-overflow-tooltip>
                  <template #default="scope">
                    <div>{{ scope.row.isChild ? '' : scope.row.spec }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="批号" align="center" width="180">
                  <template #default="scope">
                    <div v-if="scope.row.isChild">
                      {{ scope.row.batchNo }}
                    </div>
                    <el-popover :ref="'batchPop'+scope.row.id" placement="bottom-start" :width="1000" trigger="click"
                                @show="batchShow(scope)" v-else :disabled="selectItem.status===2">
                      <template #reference>
                        <div class="row-me center-all pointer"
                             v-if="scope.row.batchNosShow.length===0">
                          <div style="color: #A6AAB8;">不指定批号</div>
                          <img src="../../assets/img/bottom.png" class="margin-left10">
                        </div>
                        <div class="row-me center-all pointer" v-else>
                          <div>已选择批号({{ scope.row.batchNosShow.length }})
                          </div>
                          <img src="../../assets/img/bottom.png" class="margin-left10">
                        </div>
                      </template>
                      <el-table :ref="'multipleTable'+scope.row.id" :data="scope.row.batchNos" border
                                header-cell-class-name="table-header-style"
                                cell-class-name="table-cell-style">
                        <el-table-column label="" align="center" show-overflow-tooltip width="60">
                          <template #default="scope">
                            <el-checkbox v-model="scope.row.checked" label=""/>
                          </template>
                        </el-table-column>
                        <el-table-column prop="batchNo" label="批号" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="inStorageTime" label="入库时间" align="center" width="160"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="validityTime" label="有效期" align="center" width="160"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="costPrice" label="成本价" align="center" width="150"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column prop="avaNums" label="库存数量" align="center" width="150"
                                         show-overflow-tooltip></el-table-column>
                      </el-table>
                      <div class="row-me row-center flex-end1 margin-top10">
                        <div class="btn-blank width70 btn-height32" @click="clickBatchNoCancel(scope)">取消</div>
                        <div class="btn-blue width70 btn-height32 margin-left10" @click="clickBatchNoOk(scope)">确定
                        </div>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="validityTime" label="有效期" align="center" width="130" show-overflow-tooltip>
                  <template #default="scope">
                    <div>
                      {{ !scope.row.isChild && scope.row.batchNosShow.length > 0 ? '' : scope.row.validityTime }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="avaNums" label="库存" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <div class="row-me center-all">
                      <div>
                        {{
                          !scope.row.isChild && scope.row.batchNosShow.length > 0 ? '' : scope.row.avaNums
                        }}
                      </div>
                      <div class="margin-left5">{{ scope.row.unit || '' }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="成本价" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-tooltip placement="top" :disabled="scope.row.batchNos.length===0"
                                v-if="!scope.row.isChild && scope.row.batchNos.length>0&&scope.row.batchNosShow.length===0">
                      <template #content>
                        <div class="row-me row-center line-height30" v-for="(item,index) in scope.row.batchNos"
                             :key="index">
                          <div>生产批号：{{ item.batchNo }}</div>
                          <div class="margin-left20">数量：{{ item.avaNums }}</div>
                          <div class="margin-left20">进价：{{ item.costPrice }}</div>
                        </div>
                      </template>
                      <div class="row-me center-all">
                        {{ scope.row.costPrice }}
                        <div class="red-star margin-left5" v-if="scope.row.batchNos.length>0">
                          *
                        </div>
                      </div>
                    </el-tooltip>
                    <div v-if="scope.row.isChild">{{ scope.row.costPrice }}</div>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="130">
                  <template #header>
                    <div><span class="red-star">*</span>调拨数量</div>
                  </template>
                  <template #default="scope">
                    <div class="row-me center-all"
                         v-if="(!scope.row.isChild && scope.row.batchNosShow.length===0) || scope.row.isChild">
                      <el-popover :ref="'allocateNums'+scope.row.id" placement="top" width="200"
                                  content="当前批次库存数不足" popper-class="popover-nums-class"
                                  trigger="hover" :disabled="Number(scope.row.allocateNums)<=Number(scope.row.avaNums)">
                        <template #reference>
                          <div class="width100">
                            <el-input placeholder="请输入" style="width: 100%;"
                                      :class="{'red-border':Number(scope.row.allocateNums)>Number(scope.row.avaNums)}"
                                      v-model="scope.row.allocateNums" @input="allocateNumsChange(scope)"
                                      :disabled="selectItem.status===2">
                            </el-input>
                          </div>
                        </template>
                      </el-popover>
                      <div class="margin-left5">{{ scope.row.unit || '' }}</div>
                    </div>
                    <!--有孩子，展示求和-->
                    <div v-if="!scope.row.isChild && scope.row.batchNosShow.length>0">
                      {{ getItemTotalNum(scope.row) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="金额" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <div v-if="(!scope.row.isChild && scope.row.batchNosShow.length===0) || scope.row.isChild">
                      {{ this.$method.toFixed(Number(scope.row.costPrice) * Number(scope.row.allocateNums), 3) }}
                    </div>
                    <!--有孩子，展示求和-->
                    <div v-if="!scope.row.isChild && scope.row.batchNosShow.length>0">
                      {{ getItemTotalPrice(scope.row) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="130" v-if="selectItem.status!==2">
                  <template v-slot="scope">
                    <el-popconfirm title="是否要删除本行？" width="250" hide-icon @confirm="clickDeleteItem(scope)">
                      <template #reference>
                        <div class="row-me center-all">
                          <div class="blue-text">
                            删除
                          </div>
                        </div>
                      </template>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="row-me row-center margin-top10 margin-bottom20">
          <el-popover placement="bottom-start" width="500px" trigger="manual" :visible="medicineVisible"
                      v-if="this.$method.isEmpty(selectItem.id)||selectItem.status===1">
            <div class="overflow-auto" style="max-height: 300px;">
              <el-table :data="drugList" border header-cell-class-name="table-header-style"
                        cell-class-name="table-cell-style" @row-click="clickRow">
                <el-table-column property="name" label="药品名称" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column property="spec" label="规格" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column property="pyName" label="简码" align="center"
                                 show-overflow-tooltip></el-table-column>
              </el-table>
            </div>
            <template #reference>
              <el-input class="width300" placeholder="请输入调拨药品名称或者简码" v-model="medicine"
                        @input="inputChange" @focus="inputChange" @blur="inputBlur">
              </el-input>
            </template>
          </el-popover>
          <div class="flex1"></div>
          <div v-if="selectItem.details.length>0">
            品种：{{ selectItem.details.length }}&emsp;&emsp;数量：{{ getTotalNum }}&emsp;&emsp;总价：{{ getTotalPrice }}
          </div>
        </div>
        <div class="line-grey-heng-dashed"></div>
        <div class="row-me">
          <div class="column-me margin-right30 padding-right20" style="max-height: 500px;overflow:auto;">
            <div v-for="(item,index) in logArray" :key="index">
              <div class="row-me row-center margin-top20" v-if="showAllLog || (!showAllLog&&index<5)">
                <div class="log-title">{{ item.createTime }}</div>
                <div class="log-title margin-left20">{{ item.operator }}</div>
                <div class="log-title margin-left20">{{ item.remark }}</div>
                <div class="blue-text margin-left20" v-if="logArray.length>4&&!showAllLog&&index===4"
                     @click="showAllLog=true">
                  展开全部
                </div>
                <div class="blue-text margin-left20" v-if="logArray.length>4&&showAllLog&&index===logArray.length-1"
                     @click="showAllLog=false">
                  收起部分
                </div>
              </div>
            </div>
          </div>
          <div class="flex1"></div>
          <!--新增或者待执行状态-->
          <div class="row-me row-center flex-end margin-top20"
               v-if="this.$method.isEmpty(selectItem.id)||selectItem.status===1">
            <div class="btn-blue width120 btn-height40" @click="clickTransfer">
              确认调拨
            </div>
            <div class="btn-blank width120 btn-height40 margin-left10" @click="clickSave">保存草稿</div>
            <div class="btn-blank width120 btn-height40 margin-left10" @click="clickDelete(selectItem)"
                 v-if="!this.$method.isEmpty(selectItem.id)">
              删除
            </div>
          </div>
          <div class="row-me row-center flex-end margin-top20" v-else>
            <div class="btn-blue width120 btn-height40" @click="clickExportDetail">导出</div>
          </div>
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      orderNum: '',
      drugName: '',
      selectState: '',
      stateArray: [{id: 1, name: '待调拨'}, {id: 2, name: '已完成'}],
      selectHouseOut: '',
      selectHouseIn: '',
      houseArray: [],
      tableData: [],
      pageNo: 1,
      total: 0,
      visibleEdit: false,
      selectItem: {},//选择的对象
      selectItemOld: {},//选择的历史对象，用于关闭弹窗验证提示语
      // 以下弹窗
      medicineVisible: false,
      medicine: '',
      drugList: [],//搜索下拉药品
      showRedBorder: false,
      title: '新增调拨单',
      showAllLog: false,//显示全部日志
      logArray: [],
      canMaskClose: false,
      isSaving: false,//保存中
      canOperate: false,
    }
  },
  // 计算属性
  computed: {
    //右下角总数量
    getTotalNum() {
      let sum = 0
      for (let item of this.selectItem.details) {
        if (item.batchNosShow.length === 0) {//没有孩子
          sum += Number(item.allocateNums)
        } else {
          sum += this.getItemTotalNum(item)
        }
      }
      return this.$method.toFixed(sum, 0)
    },
    //右下角总价
    getTotalPrice() {
      let sum = 0
      for (let item of this.selectItem.details) {
        if (item.batchNosShow.length === 0) {//没有孩子
          sum += this.$method.toFixed(Number(item.costPrice) * Number(item.allocateNums), 3)
        } else {
          sum += this.getItemTotalPrice(item)
        }
      }
      return this.$method.toFixed(sum, 3)
    },
    //某一行总调拨数量
    getItemTotalNum() {
      let that = this
      return function (row) {
        let sum = 0
        for (let item of row.batchNosShow) {
          sum += Number(item.allocateNums)
        }
        return that.$method.toFixed(sum, 0);
      }
    },
    //某一行总金额
    getItemTotalPrice() {
      let that = this
      return function (row) {
        let sum = 0
        for (let item of row.batchNosShow) {
          sum += Number(item.costPrice) * Number(item.allocateNums)
        }
        return that.$method.toFixed(sum, 3)
      }
    },
  },
  // 侦听器
  watch: {},
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getHouseList()
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //调拨数量改变
    allocateNumsChange(scope) {
      scope.row.allocateNums = this.$method.checkInputZero(scope.row.allocateNums, 0)
    },
    //批号弹窗显示触发
    batchShow(scope) {
      let arr = scope.row.batchNos.filter(item => {
        return item.checked
      })
      for (let item of arr) {
        item.isChild = true
      }
      scope.row.batchNosShow = arr//用于表格二级药品显示
    },
    //批号弹窗取消
    clickBatchNoCancel(scope) {
      this.$refs['batchPop' + scope.row.id].hide()
    },
    //批号弹窗确定
    clickBatchNoOk(scope) {
      this.$refs['batchPop' + scope.row.id].hide()
      let arr = scope.row.batchNos.filter(item => {
        return item.checked
      })
      for (let item of arr) {
        item.isChild = true
      }
      scope.row.batchNosShow = arr//用于表格二级药品显示
    },
    //搜索
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.orderNum = ''
      this.drugName = ''
      this.selectState = ''
      this.selectHouseOut = ''
      this.selectHouseIn = ''
      this.pageNo = 1
      this.getData()
    },
    //新增
    clickAdd() {
      this.title = '新增调拨单'
      this.canMaskClose = false
      this.logArray = []
      this.selectItem = {
        outPharmacyId: '',
        inPharmacyId: '',
        remark: '',
        details: [],
      }
      this.selectItemOld = this.$method.deepClone(this.selectItem)
      this.medicine = ''
      this.showRedBorder = false
      this.visibleEdit = true
    },
    //编辑
    clickEdit(item) {
      this.title = '编辑调拨单'
      this.canMaskClose = false
      this.$getRequest('/admin/stockAllocate/details', {
        id: item.id
      }).then((res) => {
        if (res) {
          this.selectItem = this.$method.deepClone(res.data)
          this.logArray = res.data.logs || []
          this.selectItemOld = this.$method.deepClone(this.selectItem)
          this.medicine = ''
          this.showRedBorder = false
          this.visibleEdit = true
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //详情
    clickDetail(item) {
      this.title = '调拨单 ' + item.orderNo
      this.canMaskClose = true
      this.$getRequest('/admin/stockAllocate/details', {
        id: item.id
      }).then((res) => {
        if (res) {
          this.selectItem = this.$method.deepClone(res.data)
          this.logArray = res.data.logs || []
          this.selectItemOld = this.$method.deepClone(this.selectItem)
          this.medicine = ''
          this.showRedBorder = false
          this.visibleEdit = true
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //导出
    clickExport() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderNo: this.orderNum,
        drugName: this.drugName,
        status: this.selectState,
        outPharmacyId: this.selectHouseOut,
        inPharmacyId: this.selectHouseIn,
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/stockAllocate/export?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //详情页导出
    clickExportDetail() {
      let token = sessionStorage.getItem('token')
      let param = {
        id: this.selectItem.id,
        token: token,
      }
      let url = this.$baseUrl + '/admin/stockAllocate/detailExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //删除
    clickDelete(item) {
      this.$confirm("是否要删除此草稿？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/stockAllocate/delete', {
          id: item.id
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.visibleEdit = false
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //确认调拨
    clickTransfer() {
      if (this.isSaving) {
        this.$message.warning('保存中，请稍候')
        return;
      }
      if (this.$method.isEmpty(this.selectItem.outPharmacyId) || this.$method.isEmpty(this.selectItem.inPharmacyId)) {
        this.showRedBorder = true
        return
      }
      if (this.selectItem.outPharmacyId === this.selectItem.inPharmacyId) {
        this.$confirm("调出库房和调入库房不能是同一个库房", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
        return
      }
      if (this.selectItem.details.length === 0) {
        this.$message.error('请选择药品')
        return
      }
      //检查是否填写完整
      for (let i = 0; i < this.selectItem.details.length; i++) {
        let item = this.selectItem.details[i]
        if (item.batchNosShow.length === 0) {
          if (this.$method.isEmpty(item.allocateNums)) {
            this.$message.error('【' + item.drugName + '】请输入调拨数量')
            return
          }
          if (Number(item.allocateNums) > Number(item.avaNums)) {
            this.$message.error('【' + item.drugName + '】调拨数量不能大于库存数量')
            return
          }
        } else {
          for (let child of item.batchNosShow) {
            if (this.$method.isEmpty(child.allocateNums)) {
              this.$message.error('【' + child.drugName + '】请输入调拨数量')
              return
            }
            if (Number(child.allocateNums) > Number(child.avaNums)) {
              this.$message.error('【' + child.drugName + '】调拨数量不能大于库存数量')
              return
            }
          }
        }
      }
      this.$confirm("您确定要调拨吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isSaving = true
        //-------处理数据------
        if (!this.$method.isEmpty(this.selectItem.details) && this.selectItem.details.length > 0) {
          for (let drugItem of this.selectItem.details) {
            if (drugItem.batchNosShow.length === 0) {//没有孩子
              drugItem.price = this.$method.toFixed(Number(drugItem.costPrice) * Number(drugItem.allocateNums), 3)
            } else {//有孩子
              drugItem.price = this.getItemTotalPrice(drugItem)
            }
            //孩子
            if (!this.$method.isEmpty(drugItem.batchNosShow) && drugItem.batchNosShow.length > 0) {
              for (let child of drugItem.batchNosShow) {
                child.price = this.$method.toFixed(Number(child.costPrice) * Number(child.allocateNums), 3)
              }
            }
          }
        }
        let param = this.$method.deepClone(this.selectItem)
        param.status = 2;//v27 1待调拨(保存草稿)，2已完成（确认调拨）
        this.$postRequest('/admin/stockAllocate/update', param).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.visibleEdit = false
            this.pageNo = 1
            this.getData()
          }
          this.isSaving = false
        }).catch((error) => {
          console.log(error)
          this.isSaving = false
        })
      }).catch(() => {
      });
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //点击药品下拉
    clickRow(row, column, e) {
      this.$getRequest('/admin/stockAllocate/getInStorageDetailByDrugId', {
        pharmacyId: this.selectItem.outPharmacyId,
        drugId: row.id,
      }).then((res) => {
        if (res) {
          if (this.contains(this.selectItem.details, res.data)) {
            this.$message.error('不能添加重复药品')
            this.medicine = '' //赋值输入框
          } else {
            this.medicine = '' //赋值输入框
            this.medicineVisible = false //隐藏搜索下拉
            res.data.batchNosShow = []//用于表格展示二级药品
            res.data.batchNos = res.data.batchNos || []
            this.selectItem.details.push(res.data) //添加到表格
            this.$nextTick(() => {
              document.getElementById("drugDiv").scrollIntoView({
                behavior: "instant",
                block: "end",
              })
            })
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //处方药品输入框失去焦点隐藏药品下拉
    inputBlur() {
      this.medicineVisible = false
    },
    //处方选择药品输入框
    inputChange() {
      //动态搜索药品
      if (this.$method.isEmpty(this.selectItem.outPharmacyId)) {
        this.$message.error('请选择调出库房')
        this.medicine = ''
        return
      }
      if (this.medicine === '') {
        return
      }
      this.$getRequest('/admin/stock/getPharmacyDrug', {
        pharmacyId: this.selectItem.outPharmacyId,
        drugName: this.medicine,
      }).then((res) => {
        if (res) {
          this.drugList = res.data
          this.medicineVisible = this.drugList.length > 0
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    contains(a, obj) {
      for (let i = 0; i < a.length; i++) {
        if (a[i].drugId === obj.drugId) {
          return true;
        }
      }
      return false;
    },
    //删除某一项
    clickDeleteItem(scope) {
      console.log(scope)
      if (scope.row.isChild) {
        for (let i = 0; i < this.selectItem.details.length; i++) {
          let item = this.selectItem.details[i]
          if (item.batchNosShow && item.batchNosShow.length > 0) {
            for (let j = 0; j < item.batchNosShow.length; j++) {
              let child = item.batchNosShow[j]
              if (scope.row.id === child.id) {
                item.batchNosShow.splice(j, 1)
                for (let batchItem of item.batchNos) {
                  if (batchItem.id === child.id) {
                    batchItem.checked = false;////取消选中状态
                  }
                }
              }
            }
          }
        }
      } else {
        for (let i = 0; i < this.selectItem.details.length; i++) {
          let item = this.selectItem.details[i]
          if (item.id === scope.row.id) {
            this.selectItem.details.splice(i, 1)
          }
        }
      }
    },
    //关闭弹簧之前
    beforeClose(done) {
      //新建或者待调拨
      if (this.$method.isEmpty(this.selectItem.id) || this.selectItem.status === 1) {
        if (JSON.stringify(this.selectItem) !== JSON.stringify(this.selectItemOld)) {
          this.$confirm("是否需要保存为草稿？", "温馨提示", {
            confirmButtonText: "保存",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }).then(() => {
            this.clickSave()
          }).catch(() => {
            done()
          });
        } else {
          done()
        }
      } else {
        done()
      }
    },
    //保存草稿
    clickSave() {
      if (this.isSaving) {
        this.$message.warning('保存中，请稍候')
        return;
      }
      if (this.$method.isEmpty(this.selectItem.outPharmacyId) || this.$method.isEmpty(this.selectItem.inPharmacyId)) {
        this.showRedBorder = true
        return
      }
      if (this.selectItem.outPharmacyId === this.selectItem.inPharmacyId) {
        this.$confirm("调出库房和调入库房不能是同一个库房", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
        return
      }
      this.isSaving = true
      //-------处理数据------
      if (!this.$method.isEmpty(this.selectItem.details) && this.selectItem.details.length > 0) {
        for (let drugItem of this.selectItem.details) {
          if (drugItem.batchNosShow.length === 0) {//没有孩子
            drugItem.price = this.$method.toFixed(Number(drugItem.costPrice) * Number(drugItem.allocateNums), 3)
          } else {//有孩子
            drugItem.price = this.getItemTotalPrice(drugItem)
          }
          //孩子
          if (!this.$method.isEmpty(drugItem.batchNosShow) && drugItem.batchNosShow.length > 0) {
            for (let child of drugItem.batchNosShow) {
              child.price = this.$method.toFixed(Number(child.costPrice) * Number(child.allocateNums), 3)
            }
          }
        }
      }
      this.selectItem.status = 1;//v27 1待调拨(保存草稿)，2已完成（确认调拨）
      this.$postRequest('/admin/stockAllocate/update', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleEdit = false
          this.pageNo = 1
          this.getData()
        }
        this.isSaving = false
      }).catch((error) => {
        console.log(error)
        this.isSaving = false
      })
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取入库单
    getData() {
      this.$postFormRequest('/admin/stockAllocate/page', {
        orderNo: this.orderNum,
        drugName: this.drugName,
        status: this.selectState,
        outPharmacyId: this.selectHouseOut,
        inPharmacyId: this.selectHouseIn,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.transferManage {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .dialog-content {

    .grey-div {
      background: #F6F7F9;
      border-radius: 4px;
      padding: 10px 20px;
    }

    .log-title {
      font-size: 18px;
      color: #555F69;
    }
  }
}
</style>
